const taskTemplateActions = {
  CLOSE_TASK_TEMPLATES: 'CLOSE_TASK_TEMPLATES',
  FETCH_TASK_TEMPLATE_FOR_TASK: 'FETCH_TASK_TEMPLATE_FOR_TASK',
  FETCH_TASK_TEMPLATES: 'FETCH_TASK_TEMPLATES',
  REFRESH_TASK_TEMPLATES: 'REFRESH_TASK_TEMPLATES',
  SHOW_TASK_TEMPLATE_TASK_ERROR: 'SHOW_TASK_TEMPLATE_TASK_ERROR',
  SHOW_TASK_TEMPLATE_TASK_SUCCESS: 'SHOW_TASK_TEMPLATE_TASK_SUCCESS',
  SHOW_TASK_TEMPLATES: 'SHOW_TASK_TEMPLATES',
  SHOW_TASK_TEMPLATES_ERROR: 'SHOW_TASK_TEMPLATES_ERROR',
};

export const taskSectionNames = ['task'];

export default taskTemplateActions;
